import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "@/components/ui/sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const sessionId = location.hash
            .split("session_id=")[1]
            ?.split("&")[0];
        const exchange = async () => {
            try {
                const res = await axios.post(
                    `${API}/auth/session`,
                    { session_id: sessionId },
                    { withCredentials: true }
                );
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/studio", { state: { user: res.data }, replace: true });
            } catch (err) {
                window.history.replaceState(null, "", window.location.pathname);
                toast.error(
                    err.response?.status === 403
                        ? "That Google account isn't authorized for the studio panel."
                        : "Sign-in failed. Please try again."
                );
                navigate("/studio", { replace: true });
            }
        };
        exchange();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="flex min-h-screen items-center justify-center bg-mist">
            <div
                data-testid="auth-callback-loading"
                className="flex items-center gap-3 text-sm font-medium text-slate-500"
            >
                <Loader2 className="h-4 w-4 animate-spin" />
                Signing you in…
            </div>
        </div>
    );
};

export default AuthCallback;
